import { UserManager, UserManagerSettings } from 'oidc-client-ts';

export const createUserManager = (settings: UserManagerSettings, _: boolean): UserManager => {
  return new UserManager(settings);
};
